<template>
  <div class="aphorism">
    <div class="content">
      <div class="prefix"></div>
      <div class="text">{{ aphorismData.content }}</div>
    </div>
    <div class="time">
      <div class="title">数据更新时间</div>
      <div class="date">{{ aphorismData.createTime }}</div>
    </div>
  </div>
</template>

<script>
import {getAphorism} from "@/api/PostUrl";

export default {
  name: "mAphorism",
  data() {
    return {
      aphorismData: {
        content: '',
        createTime: '',
        author: ''
      }
    }
  },
  created() {
    this.initFun()
  },
  methods: {
    async initFun() {
      await this.getAphorism()
      await this.getDate()
    },
    // 获取名言警句
    async getAphorism() {
      const data = await this.$apiPost.httpGet(getAphorism)
      if (data) {
        this.aphorismData.content = data.content || ''
      }
    },
   async getDate(){
      const date = await new Date()._$getServerTime()
      this.aphorismData.createTime = date._$formatDate(date._$formats.zhAsDate,' 00:00:00')
    }
  }
}
</script>

<style lang="scss" scoped>
.aphorism {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  background-image: url(../../../../../../assets/image/practice/aphorism_background.jpg);
  background-position: center;
  background-repeat: no-repeat;
  padding: 0 20px;
  border-radius: 6px;
  box-sizing: border-box;
  background-size: 100% 100%;
  min-height: 73px;

  & > .content {
    flex: 1;
    font-size: calc(0.21 * var(--fontSize));
    position: relative;
    display: flex;
    align-items: center;
    height: 100%;

    & > .prefix {
      background-image: url(../../../../../../assets/image/icon/icon_douhao.png);
      background-position: center;
      background-repeat: no-repeat;
      background-size: 100% 100%;
      width: calc(0.36 * var(--fontSize));
      height: 100%;
      vertical-align: top;
      min-width: 36px;
    }

    & > .text {
      position: relative;
    }

    & > .text:before {
      content: '';
      left: 0;
      bottom: -3px;
      width: 100%;
      height: 6px;
      opacity: 0.1;
      background: rgba(36, 166, 255, 1);
      position: absolute;
    }
  }


  & > .time {
    min-width: 200px;
    display: flex;
    justify-content: space-evenly;
    align-items: flex-end;
    flex-direction: column;
    height: 100%;

    & > .title {
      font-size: calc(0.12 * var(--fontSize));
    }

    & > .date {
      font-size: calc(0.16 * var(--fontSize));
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/szrt_revision/new_account_settings/accountSettings/overallStatistics/components/mAphorism.vue